import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
// import Button from '../SelectValue/Button';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import getServices from '../../Services/get-service';
import postServices from '../../Services/post-service';
import swal from 'sweetalert';
import { format, parseISO } from 'date-fns';
import Loading from '../SelectValue/Loading';
import Constant from '../../Constant';
import Checkbox from '@mui/material/Checkbox';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import avatar from '../../Assets/images/avatar.png';
import inflow from '../../Assets/images/inflow.png';
import outflow from '../../Assets/images/outflow.png';
import Constants from '../../Constant';
import more from '../../Assets/images/more.svg';
import { Menu, MenuItem, Dialog, DialogTitle, DialogContent, Button, DialogActions, CircularProgress } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#D5C1FB',
    color: '#14013A',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function TransactionTableMain() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [transactionType, setTransactionType] = useState('');
  const [transactionStatus, setTransactionStatus] = useState(''); 
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const oneWeekAgo = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
  const [fromDate, setFromDate] = useState(oneWeekAgo);
  const [toDate, setToDate] = useState(currentDate);
  const [allTransactions, setAllTransactions] = useState([]);
  const [countData, setCountData] = useState([]);
  const [pagination, setPagination] = useState({});
  
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedTransactionDetails, setSelectedTransactionDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  
  const [reconcileLoading, setReconcileLoading] = useState(false);

  const isDateValid = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date <= today;
  };

  const filteredTransactions = allTransactions.filter((transaction) => {
    const matchesType = !transactionType || transaction.transactionType === transactionType;
    const normalizedStatus = transaction.status === 'SUCCESSFUL' ? 'Success' : 'Failed';
    const matchesStatus = !transactionStatus || normalizedStatus === transactionStatus;
    return matchesType && matchesStatus;
  });

  useEffect(() => {
    setLoading(true);
    
    getServices.getWallet()
      .then((response) => {
        setLoading(false);
        
        if (response.data.status === '2000') {
          const walletTransactions = response.data.data.walletTransactions || [];
          const paginationData = response.data.data.pagination || {};
          
          setAllTransactions(walletTransactions);
          setPagination(paginationData);
        } else {
          swal(response.data.description);
        }
      })
      .catch((error) => {
        setLoading(false);
        swal('Error fetching transactions');
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getServices.getAllCount(
          new Date().toISOString().split('T')[0],
          new Date().toISOString().split('T')[0]
        );
        if (response.data.status === '2000') {
          setCountData(response.data.data);
        } else {
          console.log('Something went wrong:', response.data.description);
        }
      } catch (error) {
        console.log('Error getting data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < Math.ceil(filteredTransactions.length / rowsPerPage) - 1) {
      setPage(page + 1);
    }
  };

  useEffect(() => {
    setPage(0);
  }, [transactionType, transactionStatus]);

  const handleOpenMenu = (event, transaction) => {
    setAnchorEl(event.currentTarget);
    setSelectedTransaction(transaction);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedTransaction(null);
  };

  const viewTransactionDetails = (reference) => {
    setLoadingDetails(true);
    setShowDetailsModal(true);
    handleCloseMenu();
    
    getServices
      .getWalletByReference(reference)
      .then((response) => {
        if (response.data.status === '2000') {
          setSelectedTransactionDetails(response.data.data);
        } else {
          swal(response.data.description);
          setShowDetailsModal(false);
        }
      })
      .catch((error) => {
        console.error('Error fetching transaction details:', error);
        swal('Failed to load transaction details');
        setShowDetailsModal(false);
      })
      .finally(() => {
        setLoadingDetails(false);
      });
  };

  const handleCloseDetailsModal = () => {
    setShowDetailsModal(false);
    setSelectedTransactionDetails(null);
  };

  const handleReconcile = () => {
    if (!selectedTransaction) return;

    const reconcileData = {};
    
    setReconcileLoading(true);
    
    postServices
      .reconcileWalletFunding(selectedTransaction.reference, reconcileData)
      .then((response) => {
        if (response.data.status === '2000') {
          swal('Success', 'Transaction reconciled successfully', 'success');
          handleCloseMenu();
          setShowDetailsModal(false);
          setAllTransactions((prev) =>
            prev.map((trans) =>
              trans.reference === selectedTransaction.reference
                ? { ...trans, status: 'SUCCESSFUL' }
                : trans
            )
          );
        } else {
          swal(response.data.description);
        }
      })
      .catch((error) => {
        console.error('Error reconciling transaction:', error);
        swal('Error', 'Failed to reconcile transaction', 'error');
      })
      .finally(() => {
        setReconcileLoading(false);
      });
  };

  const isReconcileDisabled = selectedTransaction?.status === 'SUCCESSFUL';

  return (
    <>
      <Loading open={loading} />

      <div className="my-8 flex flex-wrap items-center gap-4">
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-4">
          <div className="w-full sm:w-auto lg:col-span-2">
            <input
              placeholder="Search by name or email address"
              className="border border-gray-300 focus:border-primary-color outline-none p-2 rounded w-full"
            />
          </div>
          <div className="w-full sm:w-auto">
            <select
              className="border w-full p-3 focus:border-primary-color rounded"
              value={transactionType}
              onChange={(e) => setTransactionType(e.target.value)}
            >
              <option value="">Transaction Type</option>
              <option value="CREDIT">Credit</option>
              <option value="DEBIT">Debit</option>
            </select>
          </div>
          <div className="w-full sm:w-auto">
            <select
              className="border w-full p-3 focus:border-primary-color rounded"
              value={transactionStatus}
              onChange={(e) => setTransactionStatus(e.target.value)}
            >
              <option value="">Status</option>
              <option value="Success">Success</option>
              <option value="Failed">Failed</option>
            </select>
          </div>
          {/* <div className="w-full sm:w-auto flex gap-2 items-center">
            <p className="mb-2 pt-1">From:</p>
            <DatePicker
              className="border w-full p-3 focus:border-primary-color rounded"
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              maxDate={new Date()}
              filterDate={isDateValid}
              popperPlacement="top-end"
            />
          </div>
          <div className="w-full sm:w-auto flex gap-2 items-center">
            <p className="mb-2 pt-1">To:</p>
            <DatePicker
              className="border w-full p-3 focus:border-primary-color rounded"
              selected={toDate}
              onChange={(date) => setToDate(date)}
              maxDate={new Date()}
              filterDate={isDateValid}
              popperPlacement="top-end"
            />
          </div> */}
        </div>
      </div>

      {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 my-5">
        <div className="border-2 rounded-lg border-gray-200 p-3 lg:col-span-2">
          <img src={avatar} className="w-6 h-6" alt="avatar" />
          <p className="text-sm font-semibold text-gray-600">Total customers</p>
          <p className="text-sm font-semibold text-gray-900">
            {parseInt(countData.activeUsers ?? 0) + parseInt(countData.nonActiveUsers ?? 0) ?? 0}
          </p>
        </div>
        <div className="border-2 rounded-lg border-gray-200 p-3 lg:col-span-2">
          <img src={inflow} className="w-6 h-6" alt="inflow" />
          <p className="text-sm font-semibold text-gray-600">Total inflow</p>
          <p className="text-sm font-semibold text-gray-900">
            NGN {Constants.FormatNumber(countData.totalInflow ?? 0)}
          </p>
        </div>
        <div className="border-2 rounded-lg border-gray-200 p-3 lg:col-span-2">
          <img src={outflow} className="w-6 h-6" alt="outflow" />
          <p className="text-sm font-semibold text-gray-600">Total outflow</p>
          <p className="text-sm font-semibold text-gray-900">
            NGN {Constants.FormatNumber(countData.totalOutflow ?? 0)}
          </p>
        </div>
      </div> */}

      <div className="mt-16">
        <div className="hidden md:flex flex-row justify-between items-center bg-primary-bg rounded-t-md rounded-r-md border-primary-border border p-4">
          <Checkbox />
          <p className="text-text flex-1 text-center whitespace-normal break-words">Email</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Transaction Type</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Amount</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Charges</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Date</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Reference</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Status</p>
          <p className="text-text flex-1 text-center whitespace-normal break-words">Action</p>
        </div>

        {loading ? (
          <div>
            {[...Array(rowsPerPage)].map((_, index) => (
              <div
                key={index}
                className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white border-b border-gray-200 p-4 gap-2"
              >
                <div className="w-6 md:w-[5%]">
                  <Skeleton width={24} height={24} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="80%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width="60%" height={20} />
                </div>
                <div className="flex-1 text-left md:text-center">
                  <Skeleton width={24} height={24} />
                </div>
              </div>
            ))}
          </div>
        ) : Array.isArray(filteredTransactions) && filteredTransactions.length > 0 ? (
          <>
            <div className="md:hidden">
              {filteredTransactions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((transaction, index) => (
                <div
                  key={index}
                  className="border rounded-lg p-4 mb-3 bg-white shadow-sm"
                >
                  <p className="font-semibold">{transaction.email || 'N/A'}</p>
                  <p>
                    <b>Transaction Type:</b>{' '}
                    <span
                      className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        transaction.transactionType === 'CREDIT' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}
                    >
                      {transaction.transactionType || 'N/A'}
                    </span>
                  </p>
                  <p><b>Amount:</b> NGN {Constant.FormatNumber(transaction.amount ?? 0)}</p>
                  <p><b>Charges:</b> NGN {Constant.FormatNumber(transaction.charges ?? 0)}</p>
                  <p><b>Date:</b> {transaction.createdDate ? format(parseISO(transaction.createdDate), 'MMM d yyyy HH:mm') : 'N/A'}</p>
                   <p>
                      <b>Reference:</b> 
                      {transaction.reference ?? 'N/A'}
                    </p>
                  <p>
                    <b>Status:</b>{' '}
                    <span
                      className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        transaction.status === 'SUCCESSFUL' ? 'text-emerald-500' : 'text-rose-500'
                      }`}
                    >
                      {transaction.status === 'SUCCESSFUL' ? 'Success' : 'Failed'}
                    </span>
                  </p>
                  <div className="flex justify-end mt-2">
                    <img
                      src={more}
                      alt="More options"
                      className="cursor-pointer"
                      onClick={(e) => handleOpenMenu(e, transaction)}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="hidden md:block">
              {filteredTransactions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((transaction, index) => (
                <div
                  key={index}
                  className="flex flex-row justify-between items-center bg-white border-b border-gray-200 p-4"
                >
                  <Checkbox />
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {transaction.email || 'N/A'}
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    <span
                      className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        transaction.transactionType === 'CREDIT' ? 'text-emerald-500' : 'text-rose-500'
                      }`}
                    >
                      {transaction.transactionType || 'N/A'}
                    </span>
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    NGN {Constant.FormatNumber(transaction.amount ?? 0)}
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    NGN {Constant.FormatNumber(transaction.charges ?? 0)}
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {transaction.createdDate ? format(parseISO(transaction.createdDate), 'MMM d yyyy') : 'N/A'}
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    {transaction.reference ?? 'N/A'}
                  </p>
                  <p className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    <span
                      className={`inline-block px-2 py-1 rounded-full text-sm font-medium ${
                        transaction.status === 'SUCCESSFUL' ? 'text-emerald-500' : 'text-rose-500'
                      }`}
                    >
                      {transaction.status === 'SUCCESSFUL' ? 'Success' : 'Failed'}
                    </span>
                  </p>
                  <div className="flex-1 text-center break-words whitespace-normal min-w-0 px-1">
                    <img
                      src={more}
                      alt="More options"
                      className="mx-auto cursor-pointer"
                      onClick={(e) => handleOpenMenu(e, transaction)}
                    />
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl) && selectedTransaction?.reference === transaction.reference}
                      onClose={handleCloseMenu}
                      sx={{
                        '& .MuiPaper-root': {
                          boxShadow: 'none',
                        },
                      }}
                    >
                      <MenuItem onClick={() => viewTransactionDetails(transaction.reference)}>
                        View details
                      </MenuItem>
                      <MenuItem
                        onClick={handleReconcile}
                        disabled={isReconcileDisabled}
                        sx={{ color: isReconcileDisabled ? '#ccc' : '#ef4444' }}
                      >
                        Reconcile
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="text-center p-4 text-gray-500">
            No Transactions found
          </div>
        )}

        {Array.isArray(filteredTransactions) && filteredTransactions.length > rowsPerPage && (
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-4 mb-10">
            <button
              onClick={handlePreviousPage}
              disabled={page === 0}
              className={`px-4 py-2 rounded-lg ${
                page === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-primary-color text-white hover:bg-primary-color-dark'
              }`}
            >
              Previous
            </button>
            <p className="text-text text-sm sm:text-base">
              Page {page + 1} of {Math.ceil(filteredTransactions.length / rowsPerPage)}
            </p>
            <button
              onClick={handleNextPage}
              disabled={page >= Math.ceil(filteredTransactions.length / rowsPerPage) - 1}
              className={`px-4 py-2 rounded-lg ${
                page >= Math.ceil(filteredTransactions.length / rowsPerPage) - 1
                  ? 'bg-gray-300 cursor-not-allowed'
                  : 'bg-primary-color text-white hover:bg-primary-color-dark'
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>

      <Dialog 
        open={showDetailsModal} 
        onClose={handleCloseDetailsModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Transaction Details</DialogTitle>
        <DialogContent>
          {loadingDetails ? (
            <div className="flex justify-center items-center py-8">
              <CircularProgress />
            </div>
          ) : selectedTransactionDetails ? (
            <div className="space-y-3 pt-2">
              <div>
                <p className="text-sm text-gray-500">Reference</p>
                <p className="font-medium">{selectedTransactionDetails.reference}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="font-medium">{selectedTransactionDetails.email}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Transaction Type</p>
                <p className="font-medium">{selectedTransactionDetails.transactionType}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Amount</p>
                <p className="font-medium">NGN {Constant.FormatNumber(selectedTransactionDetails.amount ?? 0)}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Charges</p>
                <p className="font-medium">NGN {Constant.FormatNumber(selectedTransactionDetails.charges ?? 0)}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Channel</p>
                <p className="font-medium">{selectedTransactionDetails.channel}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Narration</p>
                <p className="font-medium">{selectedTransactionDetails.narration}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Gateway Status</p>
                <p className="font-medium">{selectedTransactionDetails.gatewayStatus}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Gateway Response</p>
                <p className="font-medium">{selectedTransactionDetails.gatewayResponse}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Status</p>
                <p className={`font-medium ${selectedTransactionDetails.status === 'SUCCESSFUL' ? 'text-emerald-500' : 'text-rose-500'}`}>
                  {selectedTransactionDetails.status === 'SUCCESSFUL' ? 'Success' : 'Failed'}
                </p>
              </div>
            </div>
          ) : (
            <p>No details available</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDetailsModal} sx={{ color: "#7C3AED" }}>
            Close
          </Button>
          {selectedTransactionDetails?.status !== 'SUCCESSFUL' && (
            <Button 
              onClick={handleReconcile} 
              color="error"
              disabled={reconcileLoading}
            >
              {reconcileLoading ? <CircularProgress size={24} /> : 'Reconcile'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}